import { Pipe, PipeTransform } from '@angular/core';
import { IFillSiteUserSearchViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { UserCardModel } from '@view-models/card/user-card-model';

@Pipe({
  name: 'siteUserToUser'
})
export class SiteUserToUserPipe implements PipeTransform {
  transform<T>(siteUsers: IFillSiteUserSearchViewModel[]): UserCardModel[] {
    return siteUsers.map(su => {
      return { ...su, fullName: su.userName, batchesAssigned: su.batchCount, uniqueId: su.userUniqueId };
    });
  }
}
